import script from "./NewResultsBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./NewResultsBanner.vue?vue&type=script&setup=true&lang=js"

import "./NewResultsBanner.vue?vue&type=style&index=0&id=4964668d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4964668d"]])

export default __exports__